import { Carousel } from "./../Carousel";
import { StyleSheet } from "react-native-web";
import { windowWidth, isPortable } from "./../../service/utils";

export const BannersSection = ({ banners = [] }) => <Carousel>{banners.map((item, index) => Banner(item, index))}</Carousel>

const Banner = (item, index) => {
    return (
        <div key={`${index}_${item.id}`} style={styles.item}>
            <a href={item.url} target="_blank" style={styles.link}>
                <img src={item.img} style={styles.img} />
            </a>
        </div>
    );
};

const bannerWidth = () => windowWidth() ?? "100%";
const bannerHeight = () => (isPortable() ? 140 : 324);

const styles = StyleSheet.create({
    item: {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        height: "100%",
    },
    link: {
        width: bannerWidth(),
    },
    img: {
        width: bannerWidth(),
        height: bannerHeight(),
    },
});